import { ApiError } from '@/shared/api/api-client/api-error';
import { API_AUTH_FORGOT_PASSWORD } from '@/shared/constants/bff-endpoints';


export interface ForgotPasswordPayload {
    email: string;
}


export async function forgotPassword (payload: ForgotPasswordPayload): Promise<{ ok: boolean }> {
    const res = await fetch(API_AUTH_FORGOT_PASSWORD, {
        method : 'POST',
        headers: { 'Content-Type': 'application/json' },
        body   : JSON.stringify(payload),
    });

    if (!res.ok) {
        const data = await res.json().catch(() => ({}));
        throw new ApiError(res.status, data);
    }

    return res;
}
